import { Box, Flex, Text, TextButton } from '@modusign/design-system';
import { useTranslation } from 'react-i18next';

interface MobileAttachmentListItemProps {
  attachmentType?: string;
  enableDownload: boolean;
  fileName: string | null;
  participantName: string;
  onDownload: () => void;
  onOpen: () => void;
}

export default function MobileAttachmentListItem({
  enableDownload,
  fileName,
  onDownload,
  onOpen,
  participantName,
  attachmentType,
}: MobileAttachmentListItemProps) {
  const { t } = useTranslation();
  return (
    <Box as="li" borderBottom="1px solid" borderBottomColor="lightGray500" px={7} py={6}>
      <Flex>
        <Text color="textNeutralVeryLight" fontWeight="medium" sx={{ flex: 'none', width: '65px' }}>
          {t('Global-name')}
        </Text>
        <Text ml={4}>{participantName}</Text>
      </Flex>
      {attachmentType && (
        <Flex mt={4}>
          <Text
            color="textNeutralVeryLight"
            fontWeight="medium"
            sx={{ flex: 'none', width: '65px' }}
          >
            {t('DocumentAttachmentListModal-reqeustedFile')}
          </Text>
          <Text ml={4}>{attachmentType}</Text>
        </Flex>
      )}
      <Flex mt={4}>
        <Text color="textNeutralVeryLight" fontWeight="medium" sx={{ flex: 'none', width: '65px' }}>
          {t('DocumentAttachmentListModal-attachedFile')}
        </Text>
        <Text ml={4}>{fileName}</Text>
      </Flex>
      {enableDownload && (
        <Box mt={6}>
          <TextButton onClick={onOpen}>{t('Global-view')}</TextButton>
          <TextButton ml={7} onClick={onDownload}>
            {t('Global-download')}
          </TextButton>
        </Box>
      )}
    </Box>
  );
}
